export default __webpack_public_path__ + "static/media/mobile-order-bullet-active.440338c4.svg";